import React, { ReactNode } from 'react'
import { connect } from 'react-redux'

import _ from 'lodash'

import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Immutable from 'immutable'

import { IState } from './types'

const styles = (theme: Theme) => createStyles({
  head: {
    backgroundColor: "#fff",
    position: "sticky",
    top: 0
  },
  root: {
    margin: theme.spacing.unit * 3,
    maxHeight: '93%',
    overflowX: 'auto',
  },
  tableBody: {
    maxHeight: '93%',
  },
})

interface IDatastoreProps {
  tree: object
}

interface IThemeProps extends WithStyles<typeof styles> {
  theme: Theme
}

type IAllProps = IDatastoreProps & IThemeProps

// tslint:disable-next-line
class NodeRow extends React.Component<{ rowKey: string, children: any, depth: number }, { expanded: boolean }> {
  public state = { expanded: false }

  public toggle = () => this.setState({expanded: !this.state.expanded})
  public render() {
    return (
      <>
        <TableRow onClick={this.toggle} style={{cursor: 'pointer'}}>
          <TableCell style={{paddingLeft: `${25 * this.props.depth}px`}}>{this.props.rowKey}</TableCell>
          <TableCell>{this.state.expanded ? <ExpandLess /> : <ExpandMore />}</TableCell>
        </TableRow>
        {this.state.expanded && this.props.children}
      </>
    )
  }
}

// tslint:disable-next-line
class LeafRow extends React.Component<{ rowKey: string, rowVal: string, depth: number }> {
  public render() {
    return (
      <TableRow>
        <TableCell style={{paddingLeft: `${25 * this.props.depth}px`}}>{this.props.rowKey}</TableCell>
        <TableCell>{this.props.rowVal}</TableCell>
      </TableRow>
    )
  }
}

// tslint:disable-next-line
class Datastore extends React.Component<IAllProps> {

  public render() {

    const renderTree = (t: object, depth: number = 1): ReactNode => {
      return _.toPairs(t).map(((entry: [string, any]) => {
          if (typeof entry[1] === 'string') { // return leaf row
            return <LeafRow key={entry[0]} depth={depth} rowKey={entry[0]} rowVal={entry[1]} />
          } else { // return collapsible row and recurse for children
            return <NodeRow key={entry[0]} depth={depth} rowKey={entry[0]} children={renderTree(entry[1], depth + 1)}/>
          }
        }))
      }


    const { classes, tree } = this.props

    return (
      <Paper className={classes.root}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.head}>Key</TableCell>
              <TableCell className={classes.head}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {renderTree(tree)}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

const mapStateToProps = (state: IState): IDatastoreProps => {

  /*

  state.datastore looks like this, straight from the sql.js query...

  datastore = {
    columns: ['key', 'val'],
    values: [
      [
        "ROOT/GENERAL/EULA_ACCEPTED",
        "T"
      ],
      [
        "ROOT/GENERAL/MEDIA_ALIGNMENT_ON_EXIT_MODE",
        "2"
      ],
    ]
  }

  ...and we want to map it to a tree like this...

  {
    "ROOT": {
      "CALENDAR_CONFIG": {
        "GCAL_USER": "",
        "EXCHANGE_USER_NAME": "",
        "EXCHANGE_DEL_MAILBOX": "",
        "EXCHANGE_IMP_MAILBOX": "",
        "CAL_STOP_OPT": "0",
        ........
      }
    }
  }

  ...create an array of string arrays, e.g.
  [
    ['ROOT', 'GENERAL', 'EULA_ACCEPTED'],
    ['ROOT', 'GENERAL', 'MEDIA_ALIGNMENT_ON_EXIT_MODE'],
    ...
  ]
  */

  const splitKeys: string[][] = state.datastore.values
    .map(val => {
      return val[0] as string;
    })
    .filter(key => !!key)
    .map(flatKey => {
      return flatKey.split('/')
    })

  // create an empty, Immutable Map to use as a tree
  let tree = Immutable.Map({})
  // for each string array (key path), look up the corresponding value in the state.datastore object, and deeply set that value in our tree
  splitKeys.forEach((keys: string[]) => tree = tree.setIn(keys, state.datastore.values.find(val => val[0] === keys.join('/'))![1]))

  // serialize the immutable to a plain object
  const plainTree = tree.getIn(['ROOT'], Immutable.Map()).toJS() // use the first level of children, instead of the redundant 'ROOT' level
  // sort the tree by the value type, so primitive rows appear first, then groups of data below
  const sortedTree = _.fromPairs(_.sortBy(_.toPairs(plainTree), pair => typeof pair[1]).reverse())

  const result = {
    datastore: state.datastore,
    tree: sortedTree,
  }
  return result

}

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(Datastore))



// WEBPACK FOOTER //
// ./src/Datastore.tsx